module.exports = __webpack_public_path__ + "img/ipad-en-13.5b98e21.jpg";